import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const docksForPlantWithIdQueryKey = (plantId: number | string | undefined) => [
  ...namedQueryKeyWithId("plants", plantId),
  "docks",
];
